<template>
	<div class="flex flex-col">
		<label v-if="label" class="text-sm" :for="id">
			{{ label }}
		</label>

		<DropdownInput
			v-if="type === 'dropdown'"
			:id
			v-model="modelValue"
			:value-type
			:options="options"
			:disabled="readonly"
		/>
		<OptionInput
			v-else-if="type === 'option' && options"
			v-model="modelValue"
			:label-id="id"
			:value-type
			:options="options"
			:disabled="readonly"
		/>
		<AppFieldNumeric
			v-else-if="isNumeric(valueType)"
			:id
			v-model="modelValue as number | undefined"
			:value-type
			:precision="
				precision !== undefined
					? precision
					: valueType === ValueType.Percentage
						? 2
						: 0
			"
			:grouping="valueType === ValueType.Currency"
			:prefix="valueType === ValueType.Currency ? '€' : ''"
			:suffix="valueType === ValueType.Percentage ? '%' : ''"
			:read-only="readonly"
		/>
		<AppFieldDate
			v-else-if="valueType === ValueType.Date"
			:id
			v-model="modelValue as string | undefined"
			:value-type
			:show-display-date
			:read-only="readonly"
		/>
		<InputText
			v-else
			:id
			v-model="modelValue"
			:value-type
			:read-only="readonly"
		/>
	</div>
</template>

<script setup lang="ts" generic="T extends ValueType">
import { ValueType } from "@/enums/ValueType";
import type { ValueTypeToType } from "@/models/domain/ValueTypeToType";
import { isNumeric } from "@/helpers/valueTypeHelpers";
import type { AvailableOptionTypes } from "@/composables/useOptionsToArray";
import { computed } from "vue";

const props = withDefaults(
	defineProps<{
		label?: string;
		id?: string;
		valueType?: T;
		precision?: number;
		type?: "text" | "dropdown" | "option";
		options?: AvailableOptionTypes;
		showDisplayDate?: boolean;
		readOnly?: boolean;
		readonly?: boolean;
	}>(),
	{
		id: () => crypto.randomUUID(),
		type: "text",
		showDisplayDate: true,
		readOnly: false,
		readonly: false,
	},
);

const readonly = computed(() => props.readOnly || props.readonly);

const modelValue = defineModel<ValueTypeToType<T>>();
</script>
